module.exports = __webpack_public_path__ + "img/tel@2x.3b508ac1.png";